import './BenefitsView.css';

/**
 * BenefitCard Component
 */
const BenefitCard = ({ icon, title, description }) => {
  return (
    <div className="benefit-card">
      <div className="benefit-card__icon" aria-hidden="true">
        {icon}
      </div>
      <h3 className="benefit-card__title">{title}</h3>
      <p className="benefit-card__description">{description}</p>
    </div>
  );
};

/**
 * View (UI) for Benefits Section
 * Pure presentational component
 */
export const BenefitsView = ({ benefits }) => {
  return (
    <section className="benefits">
      <div className="container">
        <div className="benefits__grid">
          {benefits.map((benefit) => (
            <BenefitCard
              key={benefit.id}
              icon={benefit.icon}
              title={benefit.title}
              description={benefit.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsView;
